import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from 'antd';
import { useCallback } from 'react';

import { CustomInputNumber } from '@app/components/CustomInputNumber';
import type { PaymentsType } from '@app/components/RecordModal/components/RecordPayment/types';
import { PaymentModalTypeEnum } from '@app/components/RecordModal/components/RecordPayment/types';
import {
  AcquiringPaymentButton,
  PaymentButton,
} from '@app/components/RecordModal/components/RecordPayment/ui';
import { divideAmount } from '@app/utils';

import '@app/components/RecordModal/components/RecordPayment/styles/Payments.desktop.scss';
import '@app/components/RecordModal/components/RecordDetails/styles/PaymentButton.desktop.scss';
import '../styles/PaymentInfo.desktop.scss';

const PF = 'payments';

export const Payments: PaymentsType = ({
  selectedAmount,
  onChangeAmount,
  paymentButtonsOptions,
  isPayFormBalanceButtonDisabled,
  handleOptionClick,
  Balance,
  acquiringPaymentMethods,
  isPayFormYooKassaButtonDisabled,
}) => {
  const onChangeAmountHandler = useCallback(
    ({ value }: { value: string }) => {
      onChangeAmount(value);
    },
    [onChangeAmount]
  );

  return (
    <div className={`${PF}__container`}>
      <div className={`${PF}__sum-container`}>
        <Typography.Text
          className={`${PF}__sum-title`}
          data-testid="payment-amount"
        >
          Сумма платежа:
        </Typography.Text>
        <CustomInputNumber
          dataTestId="payment-amount-input"
          isAllowed={(floatValue: number) => {
            return floatValue >= 1;
          }}
          inputValue={selectedAmount}
          onSuccess={onChangeAmountHandler}
        />
      </div>
      <div className={`${PF}__payments`}>
        {paymentButtonsOptions.map(({ key, ...buttonProps }) => (
          <PaymentButton key={key} {...buttonProps} />
        ))}
        <div className={`${PF}__payments-payments-buttons-without-dropdown`}>
          <Button
            className="payment-balance"
            disabled={isPayFormBalanceButtonDisabled}
            onClick={() => handleOptionClick(PaymentModalTypeEnum.BALANCE)({})}
            data-testid="balance-payment"
          >
            <div className="payment-receipt payment-component__buttons">
              <FontAwesomeIcon
                className="buttons__balance_icon button-icon"
                icon={faWallet}
              />
              <div>
                <p className="receipt-title">Оплатить с баланса</p>
                <p className="receipt-description">
                  Баланс: {divideAmount(Balance)}
                </p>
              </div>
            </div>
          </Button>
        </div>
        {acquiringPaymentMethods.map((method) => (
          <AcquiringPaymentButton
            key={method.Id}
            method={method}
            isPayFormYooKassaButtonDisabled={isPayFormYooKassaButtonDisabled}
            handleOptionClick={handleOptionClick}
          />
        ))}
      </div>
    </div>
  );
};
